import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  addUnlistedInvestor,
  addUnlistedOrder,
  editOrder,
  executeUnlistedOrder,
  getInvestorBanks,
  getUnlistedInvestors,
  getUnlistedInvoice,
  getUnlistedOrders,
  uploadUnlistedInvestorDocs,
} from "../../redux/rm/rmSlice";
import toast from "react-hot-toast";
import { colors } from "../../constants/colors";
import { formatDate } from "../../utils";
import { Close, Search, Edit } from "@mui/icons-material";
import {
  getUnlistedInventory,
  updateUnlistedOrderStatus,
} from "../../redux/admin/adminSlice";
import ExecuteUnlistedOrderModal from "../../components/Modal/Unlisted/ExecuteUnlistedOrderModal";
import { getRMUser } from "../../redux/user/userSlice";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import UploadDocumentsModal from "../../components/Modal/Unlisted/UploadDocumentsModal";
import ExecuteOrderModal from "../../components/Modal/Unlisted/ExecuteOrderModal";
import DocumentsModal from "../../components/Modal/Unlisted/DocumentsModal";

const UnlistedOrders = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const dispatch = useDispatch<any>();
  const [pageSize, setPageSize] = useState<number>(10);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filteredOrders, setFilteredOrders] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [isExecuteModalOpen, setIsExecuteModalOpen] = useState<boolean>(false);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState<boolean>(false);
  const [isDocumentsModalOpen, setIsDocumentsModalOpen] = useState<boolean>(
    false
  );
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [currentOrder, setCurrentOrder] = useState<any>(null);
  const [stocks, setStocks] = useState<any[]>([]);
  const [investors, setInvestors] = useState<any[]>([]);
  const [orderStatus, setOrderStatus] = useState<string>("ALL");
  const [orderType, setOrderType] = useState<string>("ALL");
  const [rmId, setRmId] = useState<number>(0);
  const [rms, setRms] = useState<any>([]);
  const [formData, setFormData] = useState<any>({
    inventoryId: "",
    dealDate: "",
    type: "BUY",
    quantity: "",
    rate: "",
    tcs: "",
    stampCharges: "",
    amount: "",
    netAmount: "",
    valueDate: "",
    rmId: 0,
    bankId: "",
    selectedDemat: 1,
    remarks: "",
    brokerName: "",
    brokerage: "",
  });

  // Allow user to enable manual edit for TDS & Stamp Charges
  const [isTcsEditable, setIsTcsEditable] = useState<boolean>(false);
  const [isStampEditable, setIsStampEditable] = useState<boolean>(false);

  const [isRejectModalOpen, setIsRejectModalOpen] = useState<boolean>(false);
  const [rejectReason, setRejectReason] = useState<string>("");
  const [selectedOrderId, setSelectedOrderId] = useState<number | null>(null);

  const userType = Number(localStorage.getItem("userType") || "0");
  const userName = localStorage.getItem("userName") || "";
  const userId = Number(localStorage.getItem("ID") || "0");

  const [dateRange, setDateRange] = useState<any>({
    startDate: undefined,
    endDate: undefined,
  });

  const [isExecuteOrderModalOpen, setIsExecuteOrderModalOpen] = useState(false);
  const [investorBanks, setInvestorBanks] = useState<any[]>([]);

  useEffect(() => {
    fetchInvestors();
    fetchStocks();
    fetchRms();
  }, []);

  useEffect(() => {
    fetchUnlistedOrders();
  }, [currentPage, pageSize, orderStatus, orderType, searchQuery, rmId]);

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      fetchUnlistedOrders();
    }
  }, [dateRange]);

  useEffect(() => {
    if (formData.rate && formData.quantity) {
      

      // Calculate defaults only when the respective field is NOT manually edited
      const brokerageVal = Number(formData.brokerage || 0);
      
      const amount = 
        formData.type === "BUY"
          ? Number(formData.rate - brokerageVal) * Number(formData.quantity)
          : Number(formData.rate + brokerageVal) * Number(formData.quantity);
      formData.totalAmount = amount;
      const defaultTcs = formData.type === "BUY" ? (amount * 0.1) / 100 : 0;
      const defaultStamp = 0;

      setFormData((prev: any) => {
        // For SELL orders TDS should always be 0
        const tcsVal =
          formData.type === "BUY" ? (isTcsEditable ? prev.tcs : defaultTcs) : 0;

        // Preserve API value for stampCharges when field is disabled (e.g., RM view)
        const stampVal = isStampEditable
          ? prev.stampCharges
          : prev.stampCharges || defaultStamp;

        return {
          ...prev,
          tcs: tcsVal,
          stampCharges: stampVal,
          netAmount: amount - tcsVal + stampVal,
        };
      });
    }
  }, [
    formData.rate,
    formData.quantity,
    formData.type,
    isTcsEditable,
    isStampEditable,
    formData.tcs,
    formData.stampCharges,
    formData.brokerage,
    formData.totalAmount,
  ]);

  useEffect(() => {
    fetchInvestors();
  }, [formData.rmId]);

  useEffect(() => {
    if (formData.investorId) {
      fetchInvestorBanks(formData.investorId);
    }
  }, [formData.investorId]);

  useEffect(() => {
    if (formData.type === "SELL") {
      setIsTcsEditable(false);
      setFormData((prev: any) => ({ ...prev, tcs: 0 }));
    }
  }, [formData.type]);

  const resetState = () => {
    setFormData({
      inventoryId: "",
      dealDate: "",
      type: "BUY",
      quantity: "",
      rate: "",
      tcs: "",
      stampCharges: "",
      totalAmount: "",
      netAmount: "",
      valueDate: "",
      rmId: 0,
      bankId: "",
      selectedDemat: 1,
      remarks: "",
      brokerName: "",
      brokerage: "",
    });
    setIsTcsEditable(false);
    setIsStampEditable(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const res = await dispatch(
        addUnlistedOrder({
          ...formData,
          rmId: userType === 4 ? formData.rmId : localStorage.getItem("ID"),
        })
      );

      if (res?.error?.message) {
        toast.error(res?.payload?.message);
        return;
      }
      toast.success("Order submitted successfully");
      fetchUnlistedOrders();
      handleClose();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const fetchRms = async () => {
    try {
      const fetchPageSize = 1000;
      let pageIndex = 1;
      let totalPagesForFetch = 1;
      const allRms: any[] = [];

      while (pageIndex <= totalPagesForFetch) {
        const response = await dispatch(
          getRMUser({
            userType: 2,
            pageIndex,
            pageSize: fetchPageSize,
          })
        );
        if (response?.error?.message) {
          setRms([]);
          return;
        }
        allRms.push(...(response.payload?.data || []));
        totalPagesForFetch = Math.max(1, Number(response.payload?.totalPages) || 1);
        pageIndex += 1;
      }

      setRms(
        [...allRms].sort((a: any, b: any) =>
          String(a.firstName || "").localeCompare(String(b.firstName || ""), undefined, {
            sensitivity: "base",
          })
        )
      );
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchUnlistedOrders = async () => {
    try {
      const response = await dispatch(
        getUnlistedOrders({
          rmId: userType === 4 ? rmId : localStorage.getItem("ID"),
          status: orderStatus,
          type: orderType,
          searchQuery: searchQuery,
          startDate: dateRange.startDate
            ? dayjs(dateRange.startDate).format("YYYY-MM-DD")
            : "",
          endDate: dateRange.endDate
            ? dayjs(dateRange.endDate).format("YYYY-MM-DD")
            : "",
          pageIndex: currentPage,
          pageSize: pageSize,
        })
      );
      if (response?.error?.message) {
        console.error(
          "Failed to fetch unlisted investors:",
          response?.payload?.message
        );
        toast.error("No Data Found...");
        setFilteredOrders([]);
        setTotalPages(0);
        return;
      }
      const data = response?.payload?.data;
      setFilteredOrders(data?.data || []);
      setTotalPages(data?.totalPages || 0);
    } catch (error) {
      console.error("Error fetching unlisted investors:", error);
    }
  };

  const onPageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setCurrentPage(newPage + 1);
  };

  const onPageSizeChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  const fetchStocks = async () => {
    try {
      const fetchPageSize = 1000;
      let pageIndex = 1;
      let totalPagesForFetch = 1;
      const allStocks: any[] = [];

      while (pageIndex <= totalPagesForFetch) {
        const response = await dispatch(
          getUnlistedInventory({ pageSize: fetchPageSize, pageIndex })
        );
        if (response?.error?.message) {
          setStocks([]);
          return;
        }
        const data = response.payload?.data;
        allStocks.push(...(data?.data || []));
        totalPagesForFetch = Math.max(1, Number(data?.totalPages) || 1);
        pageIndex += 1;
      }

      setStocks(
        [...allStocks].sort((a: any, b: any) =>
          String(a.stockName || "").localeCompare(String(b.stockName || ""), undefined, {
            sensitivity: "base",
          })
        )
      );
    } catch (error) {
      console.error("Error fetching stocks:", error);
    }
  };

  const fetchInvestors = async () => {
    try {
      const fetchPageSize = 1000;
      let pageIndex = 1;
      let totalPagesForFetch = 1;
      const allInvestors: any[] = [];
      const resolvedRmId = userType === 4 ? formData.rmId || null : userId;

      while (pageIndex <= totalPagesForFetch) {
        const response = await dispatch(
          getUnlistedInvestors({
            pageSize: fetchPageSize,
            pageIndex,
            rmId: resolvedRmId,
          })
        );
        if (response?.error?.message) {
          setInvestors([]);
          return;
        }
        const data = response.payload?.data;
        allInvestors.push(...(data?.data || []));
        totalPagesForFetch = Math.max(1, Number(data?.totalPages) || 1);
        pageIndex += 1;
      }

      setInvestors(
        [...allInvestors].sort((a: any, b: any) =>
          String(a.name || "").localeCompare(String(b.name || ""), undefined, {
            sensitivity: "base",
          })
        )
      );
    } catch (error) {
      console.error("Error fetching investors:", error);
    }
  };

  // Modified handleStatusChange to accept rejection reason
  const handleStatusChange = async (
    orderId: number,
    status: string,
    reason: string = ""
  ) => {
    try {
      await dispatch(
        updateUnlistedOrderStatus({ orderId, status, remarks: reason })
      )
        .then(async () => {
          // If admin accepts and all docs are present, auto-upload and generate invoice
          if (status === "APPROVED") {
            const order = filteredOrders.find((o) => o.id === orderId);
            if (
              order &&
              // order.panDoc &&
              order.cmlDoc
              // order.cancelledChequeDoc
            ) {
              const formData = new FormData();
              formData.append("investorId", order.investorId);
              formData.append("orderId", order.id);
              formData.append("investorPAN", order.investorPAN);
              const uploadRes = await dispatch(
                uploadUnlistedInvestorDocs(formData)
              );
              if (uploadRes?.error?.message) {
                toast.error(uploadRes?.payload?.message);
              } else {
                const invoiceRes = await dispatch(
                  getUnlistedInvoice({
                    orderId: order.id,
                    userId: order.investorId,
                  })
                );
                if (invoiceRes?.error?.message) {
                  toast.error(
                    invoiceRes?.payload?.message || "Something went wrong!"
                  );
                }
              }
            }
          }
          fetchUnlistedOrders();
          toast.success("Order updated successfully");
        })
        .catch((error: any) => {
          console.error(`Error changing status for ID: ${orderId}`, error);
          toast.error("Error updating order status");
        });
    } catch (error) {
      console.error("Error changing status:", error);
      toast.error("Error updating order status");
    }
  };
  // New function to open reject modal
  const handleOpenRejectModal = (orderId: number) => {
    setSelectedOrderId(orderId);
    setRejectReason("");
    setIsRejectModalOpen(true);
  };

  // New function to handle reject submission
  const handleRejectSubmit = async () => {
    if (!rejectReason.trim()) {
      toast.error("Please provide a rejection reason");
      return;
    }
    if (selectedOrderId) {
      await handleStatusChange(selectedOrderId, "REJECTED", rejectReason);
      setIsRejectModalOpen(false);
      setRejectReason("");
      setSelectedOrderId(null);
    }
  };

  // New function to close reject modal
  const handleRejectModalClose = () => {
    setIsRejectModalOpen(false);
    setRejectReason("");
    setSelectedOrderId(null);
  };

  const handleUpload = (data: any) => {
    if (
      // (!currentOrder?.panDoc && !data.panDoc) ||
      !currentOrder?.cmlDoc &&
      !data.cmlDoc
      // (!currentOrder?.cancelledChequeDoc && !data.cancelledChequeDoc)
    ) {
      toast.error("Please upload all documents");
      return;
    }

    const formData = new FormData();
    formData.append("investorId", currentOrder?.investorId);
    formData.append("orderId", currentOrder?.id);
    formData.append("investorPAN", currentOrder?.investorPAN);
    if (!currentOrder?.panDoc && data.panDoc)
      formData.append("panDoc", data?.panDoc);
    if (!currentOrder?.cmlDoc && data.cmlDoc)
      formData.append("cmlDoc", data?.cmlDoc);
    if (!currentOrder?.cancelledChequeDoc && data.cancelledChequeDoc)
      formData.append("cancelledChequeDoc", data?.cancelledChequeDoc);

    dispatch(uploadUnlistedInvestorDocs(formData))
      .then(async (response: any) => {
        if (response?.error?.message) {
          toast.error(response?.payload?.message);
          return;
        }
        const invoiceRes = await dispatch(
          getUnlistedInvoice({
            orderId: currentOrder?.id,
            userId: currentOrder?.investorId,
          })
        );

        if (invoiceRes?.error?.message) {
          toast.error(invoiceRes?.payload?.message);
          return;
        }
        toast.success("Order updated successfully");
        fetchUnlistedOrders();
      })
      .catch((error: any) => {
        console.error("Error executing order:", error);
        toast.error("Error executing order");
      });

    setIsExecuteModalOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    resetState();
  };

  const handleEditOrder = (order: any) => {
    setCurrentOrder(order);
    setFormData({
      ...order,
      inventoryId: order.inventoryId,
      quantity: order.quantity,
      rate: order.rate,
      dealDate: dayjs(order.dealDate).format("YYYY-MM-DD"),
      valueDate: dayjs(order.valueDate).format("YYYY-MM-DD"),
      bankId: order.bankId,
      selectedDemat: order.selectedDemat || 1,
      remarks: order.remarks,
      brokerage: order.brokerage,
    });
    // Allow admin to edit stamp charges inside edit modal
    setIsStampEditable(userType === 4);
    setIsEditModalOpen(true);
  };

  const handleEditClose = () => {
    setIsEditModalOpen(false);
    setCurrentOrder(null);
    resetState();
  };

  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // If admin modifies stamp charges, keep the manual value
    if (name === "stampCharges" && userType === 4) {
      setIsStampEditable(true);
    }
    const numericFields = ['quantity', 'rate', 'stampCharges', 'brokerage'];
    setFormData((prev: any) => ({
      ...prev,
      [name]: numericFields.includes(name) ? (value === '' ? '' : Number(value)) : value,
    }));
  };

  const handleEditSubmit = async () => {
    try {
      const updateData = {
        orderId: currentOrder.id,
        inventoryId: formData.inventoryId,
        quantity: formData.quantity,
        rate: formData.rate,
        dealDate: formData.dealDate,
        valueDate: formData.valueDate,
        bankId: formData.bankId,
        selectedDemat: formData.selectedDemat,
        stampCharges: formData.stampCharges,
        brokerage: formData.brokerage,
        remarks: formData.remarks,
      };

      const res = await dispatch(editOrder(updateData));
      if (res?.error?.message) {
        toast.error(res?.payload?.message);
        return;
      }
      toast.success("Order updated successfully");
      fetchUnlistedOrders();
      handleEditClose();
    } catch (error) {
      console.error("Error updating order:", error);
      toast.error("Error updating order");
    }
  };

  const exportData = async () => {
    const response = await dispatch(
      getUnlistedOrders({
        rmId: userType === 4 ? rmId : localStorage.getItem("ID"),
        status: orderStatus,
        type: orderType,
        searchQuery: searchQuery,
        startDate: dateRange.startDate
          ? dayjs(dateRange.startDate).format("YYYY-MM-DD")
          : "",
        endDate: dateRange.endDate
          ? dayjs(dateRange.endDate).format("YYYY-MM-DD")
          : "",
        pageIndex: 1,
        pageSize: 10000,
      })
    );

    const orders = response?.payload?.data?.data || [];
    const data = orders.map((order: any) => ({
      "Scrip Name": order.stockName,
      "Investor Name": order.investorName,
      Type: order.type,
      Quantity: order.quantity,
      Rate: order.rate,
      Status: order.status,
      ...(userType === 4 ? { "RM Name": order.rmName } : {}),
      "Deal Date": formatDate(order.dealDate),
      "Value Date": formatDate(order.valueDate),
      Remarks: order.remarks,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

    XLSX.writeFile(workbook, "orders_export.xlsx");
  };

  const handleExecution = async (status: any) => {
    try {
      const response = await dispatch(
        executeUnlistedOrder({ orderId: currentOrder?.id, ...status })
      );
      if (response?.error?.message) {
        toast.error(response?.payload?.message);
        return;
      }
      toast.success("Order completed successfully");
      fetchUnlistedOrders();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownloadInvoice = async () => {
    if (currentOrder?.invoicePath) {
      const a = document.createElement("a");
      a.href = process.env.REACT_APP_DOWNLOAD_URL + currentOrder?.invoicePath;
      a.download = "invoice.pdf";
      a.target = "_blank";
      a.click();
    }
  };

  const extractInvoiceMessage = (value: any, fallback: string) => {
    if (!value) return fallback;
    if (typeof value === "string") return value;
    if (typeof value?.message === "string") return value.message;
    if (typeof value?.message?.message === "string") return value.message.message;
    try {
      return JSON.stringify(value);
    } catch {
      return fallback;
    }
  };

  const handleRegenerateInvoice = async () => {
    if (!currentOrder?.id || !currentOrder?.investorId) {
      return {
        success: false,
        message: "Order details are incomplete. Cannot regenerate invoice.",
      };
    }

    try {
      const invoiceRes: any = await dispatch(
        getUnlistedInvoice({
          orderId: currentOrder.id,
          userId: currentOrder.investorId,
        })
      );

      if (invoiceRes?.error) {
        return {
          success: false,
          message: extractInvoiceMessage(
            invoiceRes?.payload?.message ?? invoiceRes?.payload,
            "Failed to generate invoice."
          ),
        };
      }

      const refreshed: any = await dispatch(
        getUnlistedOrders({
          rmId: userType === 4 ? rmId : localStorage.getItem("ID"),
          status: orderStatus,
          type: orderType,
          searchQuery: searchQuery,
          startDate: dateRange.startDate
            ? dayjs(dateRange.startDate).format("YYYY-MM-DD")
            : "",
          endDate: dateRange.endDate
            ? dayjs(dateRange.endDate).format("YYYY-MM-DD")
            : "",
          pageIndex: currentPage,
          pageSize: pageSize,
        })
      );

      if (!refreshed?.error) {
        const orders = refreshed?.payload?.data?.data || [];
        setFilteredOrders(orders);
        setTotalPages(refreshed?.payload?.data?.totalPages || 0);
        const updatedOrder = orders.find((o: any) => o.id === currentOrder.id);
        if (updatedOrder) {
          setCurrentOrder(updatedOrder);
        }
      }

      return {
        success: true,
        message: "Invoice generated successfully.",
      };
    } catch (error: any) {
      const timeoutMessage =
        error?.code === "ECONNABORTED"
          ? "Invoice generation timed out. Please check bank/IFSC details and try again."
          : null;
      return {
        success: false,
        message:
          timeoutMessage ||
          extractInvoiceMessage(
            error?.response?.data?.message ?? error?.message ?? error,
            "Failed to generate invoice."
          ),
      };
    }
  };

  const fetchInvestorBanks = async (investorId: string) => {
    try {
      const response = await dispatch(getInvestorBanks({ userId: investorId }));
      setInvestorBanks(response?.payload?.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Helper function to check if all KYC documents are uploaded
  const isKYCDocsUploaded = (order: any) => {
    return order?.panDoc || order?.cmlDoc || order?.cancelledChequeDoc;
  };

  return (
    <div
      className="min-h-screen bg-lightBg py-8 px-4 sm:px-6 lg:px-8"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <Box
        width="90%"
        mb={2}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" style={{ textAlign: "left" }}>
          Order Details
        </Typography>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
          >
            Create Order
          </Button>
          <Button variant="outlined" color="primary" onClick={exportData}>
            Export Data
          </Button>
        </Box>
      </Box>

      {/* Filters and Sorting */}
      <Box
        width="90%"
        mb={2}
        mt={2}
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          alignItems: "center",
        }}
      >
        <TextField
          variant="outlined"
          placeholder="Search users"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          sx={{
            flex: 1,
            minWidth: { xs: "100%", sm: "200px" }, // Full width on mobile
            maxWidth: "300px",
          }}
        />

        <FormControl
          sx={{
            minWidth: { xs: "100%", sm: "200px" }, // Full width on xs, fixed on sm+
          }}
        >
          <InputLabel id="onboard-status-label">Order Status</InputLabel>
          <Select
            labelId="onboard-status-label"
            value={orderStatus}
            onChange={(e) => setOrderStatus(e.target.value)}
            displayEmpty
            label="Order Status"
          >
            <MenuItem value="ALL">ALL</MenuItem>
            <MenuItem value="COMPLETED">Complete</MenuItem>
            <MenuItem value="PARTIALLY_COMPLETED">Partially Complete</MenuItem>
            <MenuItem value="UPLOADED">Uploaded</MenuItem>
            <MenuItem value="PENDING">Pending</MenuItem>
            <MenuItem value="APPROVED">Approved</MenuItem>
            <MenuItem value="REJECTED">Rejected</MenuItem>
          </Select>
        </FormControl>

        <FormControl
          sx={{
            minWidth: { xs: "100%", sm: "200px" },
          }}
        >
          <InputLabel id="order-type-label">Order Type</InputLabel>
          <Select
            labelId="order-type-label"
            value={orderType}
            onChange={(e) => setOrderType(e.target.value)}
            displayEmpty
            label="Order Type"
          >
            <MenuItem value="ALL">ALL</MenuItem>
            <MenuItem value="BUY">BUY</MenuItem>
            <MenuItem value="SELL">SELL</MenuItem>
          </Select>
        </FormControl>

        {userType === 4 && (
          <FormControl
            sx={{
              minWidth: { xs: "100%", sm: "200px" },
            }}
          >
            <InputLabel id="rm-label">RM</InputLabel>
            <Select
              labelId="rm-label"
              value={rmId}
              onChange={(e) => setRmId(Number(e.target.value))}
              displayEmpty
              label="RM"
            >
              <MenuItem value={0}>All RMs</MenuItem>
              {rms.map((rm: any) => (
                <MenuItem key={rm.id} value={rm.id}>
                  {rm.firstName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Start Date"
            value={dateRange.startDate}
            onChange={(newValue) =>
              setDateRange({ ...dateRange, startDate: newValue })
            }
            slotProps={{
              textField: {
                sx: { minWidth: { xs: "100%", sm: "200px" } },
              },
            }}
          />
        </LocalizationProvider>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="End Date"
            value={dateRange.endDate}
            onChange={(newValue) =>
              setDateRange({ ...dateRange, endDate: newValue })
            }
            slotProps={{
              textField: {
                sx: { minWidth: { xs: "100%", sm: "200px" } },
              },
            }}
          />
        </LocalizationProvider>
      </Box>

      <div style={{ display: "flex", justifyContent: "center", width: "90%" }}>
        <TableContainer
          component={Paper}
          style={{ width: "100%", marginTop: "1rem" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Scrip Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Investor Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Type
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Quantity
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Rate
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Brokerage
                </TableCell>                
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Status
                </TableCell>
                {userType === 4 && (
                  <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                    RM Name
                  </TableCell>
                )}
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Deal Date
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Value Date
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Remarks
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {setFilteredOrders.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    <Typography variant="body2" color="textSecondary">
                      No Orders Found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredOrders.map((order) => (
                  <TableRow key={order.id}>
                    <TableCell>
                      <Button>{order.stockName}</Button>
                    </TableCell>
                    <TableCell>{order?.investorName}</TableCell>
                    <TableCell>{order?.type}</TableCell>
                    <TableCell>{order?.quantity}</TableCell>
                    <TableCell>{order?.rate}</TableCell>
                    <TableCell>{order?.brokerage}</TableCell>
                    <TableCell>
                      <Chip
                        label={order?.status}
                        color={
                          order?.status === "APPROVED"
                            ? "success"
                            : order?.status === "REJECTED"
                            ? "error"
                            : order?.status === "PENDING"
                            ? "warning"
                            : order?.status === "COMPLETED"
                            ? "info"
                            : order?.status === "UPLOADED"
                            ? "info"
                            : order?.status === "PARTIALLY_COMPLETED"
                            ? "warning"
                            : "default"
                        }
                        variant="outlined"
                        size="small"
                      />
                    </TableCell>
                    {userType === 4 && <TableCell>{order?.rmName}</TableCell>}
                    <TableCell>{formatDate(order.dealDate)}</TableCell>
                    <TableCell>
                      {order.valueDate ? formatDate(order.valueDate) : "-"}
                    </TableCell>
                    <TableCell>{order.remarks ? order.remarks : "-"}</TableCell>
                    {userType === 4 ? (
                      <TableCell>
                        {order?.status === "PENDING" ? (
                          <div className="flex gap-2">
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                backgroundColor: "#4caf50",
                                "&:hover": { backgroundColor: "#388e3c" },
                                textTransform: "none",
                                borderRadius: "8px",
                                px: 2,
                                py: 0.5,
                              }}
                              onClick={() =>
                                handleStatusChange(order.id, "APPROVED")
                              }
                            >
                              Accept
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                color: "#f44336",
                                borderColor: "#f44336",
                                "&:hover": {
                                  backgroundColor: "#fdecea",
                                  borderColor: "#d32f2f",
                                },
                                textTransform: "none",
                                borderRadius: "8px",
                                px: 2,
                                py: 0.5,
                              }}
                              onClick={() => handleOpenRejectModal(order.id)}
                            >
                              Reject
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                color: "#1976d2",
                                borderColor: "#1976d2",
                                "&:hover": {
                                  backgroundColor: "#e3f2fd",
                                  borderColor: "#1565c0",
                                },
                                textTransform: "none",
                                borderRadius: "8px",
                                px: 2,
                                py: 0.5,
                              }}
                              onClick={() => handleEditOrder(order)}
                            >
                              Edit
                            </Button>
                          </div>
                        ) : order?.status === "UPLOADED" ? (
                          <div className="flex gap-2">
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                backgroundColor: "#4caf50",
                                "&:hover": { backgroundColor: "#388e3c" },
                                textTransform: "none",
                                borderRadius: "8px",
                              }}
                              onClick={() => {
                                setCurrentOrder(order);
                                setIsExecuteOrderModalOpen(true);
                              }}
                            >
                              Complete
                            </Button>
                            <Button
                              variant="outlined"
                              size="small"
                              disabled={!isKYCDocsUploaded(order)}
                              sx={{
                                color: isKYCDocsUploaded(order)
                                  ? "#1976d2"
                                  : "#9e9e9e",
                                borderColor: isKYCDocsUploaded(order)
                                  ? "#1976d2"
                                  : "#e0e0e0",
                                "&:hover": isKYCDocsUploaded(order)
                                  ? {
                                      backgroundColor: "#e3f2fd",
                                      borderColor: "#1565c0",
                                    }
                                  : {},
                                textTransform: "none",
                                borderRadius: "8px",
                              }}
                              onClick={() => {
                                setCurrentOrder(order);
                                setIsDocumentsModalOpen(true);
                              }}
                            >
                              Invoice
                            </Button>
                          </div>
                        ) : order?.status === "COMPLETED" ||
                          order?.status === "APPROVED" ? (
                          <Button
                            variant="outlined"
                            size="small"
                            disabled={!isKYCDocsUploaded(order)}
                            sx={{
                              color: isKYCDocsUploaded(order)
                                ? "#1976d2"
                                : "#9e9e9e",
                              borderColor: isKYCDocsUploaded(order)
                                ? "#1976d2"
                                : "#e0e0e0",
                              "&:hover": isKYCDocsUploaded(order)
                                ? {
                                    backgroundColor: "#e3f2fd",
                                    borderColor: "#1565c0",
                                  }
                                : {},
                              textTransform: "none",
                              borderRadius: "8px",
                            }}
                            onClick={() => {
                              setCurrentOrder(order);
                              setIsDocumentsModalOpen(true);
                            }}
                          >
                            Invoice
                          </Button>
                        ) : order?.status === "PARTIALLY_COMPLETED" ? (
                          <Button
                            variant="contained"
                            size="small"
                            sx={{
                              backgroundColor: "#ff9800",
                              "&:hover": { backgroundColor: "#f57c00" },
                              textTransform: "none",
                              borderRadius: "8px",
                            }}
                            onClick={() => {
                              setCurrentOrder(order);
                              setIsExecuteOrderModalOpen(true);
                            }}
                          >
                            Complete Order
                          </Button>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            {order?.status}
                          </Typography>
                        )}
                      </TableCell>
                    ) : (
                      <TableCell>
                        {order?.status === "APPROVED" ? (
                          <div className="flex gap-2">
                            <Button
                              variant="contained"
                              size="small"
                              sx={{
                                backgroundColor: "#4caf50",
                                "&:hover": { backgroundColor: "#388e3c" },
                                textTransform: "none",
                                borderRadius: "8px",
                                px: 2,
                                py: 0.5,
                              }}
                              onClick={() => {
                                setIsUploadModalOpen(true);
                                setCurrentOrder(order);
                              }}
                            >
                              Upload
                            </Button>
                          </div>
                        ) : order?.status === "PENDING" ? (
                          <div className="flex gap-2">
                            <Button
                              variant="outlined"
                              size="small"
                              sx={{
                                color: "#1976d2",
                                borderColor: "#1976d2",
                                "&:hover": {
                                  backgroundColor: "#e3f2fd",
                                  borderColor: "#1565c0",
                                },
                                textTransform: "none",
                                borderRadius: "8px",
                                px: 2,
                                py: 0.5,
                              }}
                              onClick={() => handleEditOrder(order)}
                            >
                              Edit
                            </Button>
                          </div>
                        ) : (
                          <Typography variant="body2" color="textSecondary">
                            {order?.status}
                          </Typography>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                ))
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  count={totalPages * pageSize}
                  rowsPerPage={pageSize}
                  page={currentPage - 1}
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onPageSizeChange}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${currentPage} – ${totalPages}`
                  }
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 800,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
            borderRadius: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="h6">Create Order</Typography>
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </Box>

          <Box component="form" noValidate autoComplete="off">
            <div className="grid grid-cols-2 gap-4">
              {/* Radio button buy/sell */}
              <FormControl
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 4,
                  alignItems: "center",
                }}
              >
                <FormLabel id="order-type-group-label">Order Type</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="order-type-buttons-group-label"
                  defaultValue="BUY"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="BUY"
                    control={<Radio />}
                    label="Buy"
                  />
                  <FormControlLabel
                    value="SELL"
                    control={<Radio />}
                    label="Sell"
                  />
                </RadioGroup>
              </FormControl>
              <div className="col-span-2"></div>
              <TextField
                label="Scrip Name"
                name="inventoryId"
                value={formData.inventoryId}
                onChange={handleChange}
                select
                fullWidth
                required
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        maxHeight: 300, // or any suitable height
                      },
                    },
                  },
                }}
              >
                {stocks.map((stock) => (
                  <MenuItem key={stock.id} value={stock.id}>
                    {stock.stockName}
                  </MenuItem>
                ))}
              </TextField>
              {userType === 4 ? (
                <FormControl fullWidth required variant="outlined">
                  <InputLabel id="rm-label">Select RM</InputLabel>
                  <Select
                    labelId="rm-label"
                    onChange={(e) =>
                      setFormData((prev: any) => ({
                        ...prev,
                        rmId: e.target.value,
                      }))
                    }
                    label="Select RM"
                    value={formData?.rmId || ""}
                  >
                    {rms.map((rm: any) => (
                      <MenuItem key={rm.id} value={rm.id}>
                        {rm.firstName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  label="RM Name"
                  name="rmId"
                  value={userName}
                  disabled
                  onChange={handleChange}
                  fullWidth
                  required
                />
              )}
              <TextField
                label="Investor Name"
                name="investorId"
                value={formData.investorId}
                onChange={handleChange}
                select
                fullWidth
                required
              >
                {investors.map((inv) => (
                  <MenuItem key={inv.id} value={inv.id}>
                    {`${inv.name} (${inv.pan})`}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                label="Deal Date"
                name="dealDate"
                type="date"
                value={formData.dealDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
              />

              <TextField
                label="Quantity"
                name="quantity"
                type="number"
                value={formData.quantity}
                onChange={(e) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    quantity: Number(e.target.value),
                  }));
                }}
                fullWidth
                required
              />

              <TextField
                label="Price"
                name="rate"
                type="number"
                value={formData.rate}
                onChange={(e) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    rate: Number(e.target.value),
                  }));
                }}
                fullWidth
                required
              />

              {/* Name of Broker - Optional */}
              <TextField
                label="Name of Broker"
                name="brokerName"
                type="text"
                value={formData.brokerName}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              {/* Brokerage - Optional */}
              <TextField
                label="Brokerage"
                name="brokerage"
                type="number"
                value={formData.brokerage}
                onChange={(e) =>
                  setFormData((prev: any) => ({
                    ...prev,
                    brokerage: Number(e.target.value),
                  }))
                }
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              {formData.type === "BUY" && (
                <TextField
                  label="TDS"
                  name="tcs"
                  type="number"
                  value={formData.tcs}
                  onChange={(e) =>
                    setFormData((prev: any) => ({
                      ...prev,
                      tcs: Number(e.target.value),
                    }))
                  }
                  fullWidth
                  disabled={!isTcsEditable}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => setIsTcsEditable((prev) => !prev)}
                        >
                          <Edit fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              )}

              <TextField
                label="Stamp Charges"
                name="stampCharges"
                type="number"
                value={formData.stampCharges}
                onChange={(e) =>
                  setFormData((prev: any) => ({
                    ...prev,
                    stampCharges: Number(e.target.value),
                  }))
                }
                fullWidth
                disabled={!isStampEditable}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() => setIsStampEditable((prev) => !prev)}
                      >
                        <Edit fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />




              <TextField
                label="Net Amount"
                name="netAmount"
                type="number"
                value={formData.netAmount}
                onChange={handleChange}
                fullWidth
                disabled
                InputLabelProps={{ shrink: true }}
              />

              <TextField
                label="Value Date"
                name="valueDate"
                type="date"
                value={formData.valueDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
              />

              <TextField
                label="Bank Account No"
                name="bankId"
                value={formData.bankId}
                onChange={handleChange}
                select
                fullWidth
                required
              >
                {investorBanks.map((bank) => (
                  <MenuItem key={bank.id} value={bank.id}>
                    {bank.bankAccNo}
                    {bank.bankName ? ` (${bank.bankName})` : ""}
                  </MenuItem>
                ))}
              </TextField>

              {(() => {
                const selectedInv = investors.find((inv) => inv.id === formData.investorId);
                if (!selectedInv) return null;
                return (
                  <TextField
                    label="Demat Account"
                    name="selectedDemat"
                    value={formData.selectedDemat || 1}
                    onChange={handleChange}
                    select
                    fullWidth
                    required
                  >
                    <MenuItem value={1}>
                      {selectedInv.dpName || "Demat 1"} ({selectedInv.dpId || "No DP ID"})
                    </MenuItem>
                    {selectedInv.dpId2 && (
                      <MenuItem value={2}>
                        {selectedInv.dpName2 || "Demat 2"} ({selectedInv.dpId2})
                      </MenuItem>
                    )}
                  </TextField>
                );
              })()}

              <TextField
                label="Remarks"
                name="remarks"
                type="text"
                value={formData.remarks}
                onChange={handleChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </div>

            <div className="mt-4 flex justify-end gap-4">
              <Button onClick={handleClose} color="secondary">
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                variant="contained"
                className="bg-blue-600 text-white"
                disabled={
                  !formData.dealDate ||
                  !formData.quantity ||
                  !formData.rate ||
                  !formData.investorId ||
                  !formData.inventoryId
                }
              >
                Submit
              </Button>
            </div>
          </Box>
        </Box>
      </Modal>
      <ExecuteOrderModal
        open={isExecuteOrderModalOpen}
        setOpen={setIsExecuteOrderModalOpen}
        order={currentOrder}
        onExecuteOrder={handleExecution}
      />
      <UploadDocumentsModal
        open={isUploadModalOpen}
        setOpen={setIsUploadModalOpen}
        onDocumentsUploaded={handleUpload}
        order={currentOrder}
      />
      <DocumentsModal
        open={isDocumentsModalOpen}
        onClose={() => setIsDocumentsModalOpen(false)}
        onDownloadInvoice={handleDownloadInvoice}
        onSendInvoice={() => {}}
        onRegenerateInvoice={handleRegenerateInvoice}
        order={currentOrder}
      />

      {/* Edit Order Modal */}
      <Modal open={isEditModalOpen} onClose={handleEditClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            maxHeight: "90vh",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
            borderRadius: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="h6">Edit Order</Typography>
            <IconButton onClick={handleEditClose}>
              <Close />
            </IconButton>
          </Box>

          <Box component="form" noValidate autoComplete="off">
            <div className="grid grid-cols-2 gap-4">
              {/* Investor Name - Disabled */}
              <TextField
                label="Investor Name"
                name="investorName"
                value={formData?.investorName || ""}
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              {/* Stock Name - Disabled */}
              <TextField
                label="Stock Name"
                name="stockName"
                value={formData?.stockName || ""}
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              {/* Quantity - Editable */}
              <TextField
                label="Quantity"
                name="quantity"
                type="number"
                value={formData.quantity}
                onChange={handleEditChange}
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
              />

              {/* Rate - Editable */}
              <TextField
                label="Rate"
                name="rate"
                type="number"
                value={formData.rate}
                onChange={handleEditChange}
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
              />

              {/* Stamp Charges - Admin editable */}
              <TextField
                label="Stamp Charges (0.015%)"
                name="stampCharges"
                type="number"
                value={formData.stampCharges}
                onChange={handleEditChange}
                fullWidth
                disabled={!isStampEditable}
                InputLabelProps={{ shrink: true }}
              />

              {/* Deal Date - Editable */}
              <TextField
                label="Deal Date"
                name="dealDate"
                type="date"
                value={formData.dealDate}
                onChange={handleEditChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
              />

              {/* Value Date - Editable */}
              <TextField
                label="Value Date"
                name="valueDate"
                type="date"
                value={formData.valueDate}
                onChange={handleEditChange}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />

              {/* Bank ID - Editable */}
              <TextField
                label="Bank Account No"
                name="bankId"
                value={formData.bankId}
                onChange={handleEditChange}
                select
                fullWidth
                InputLabelProps={{ shrink: true }}
              >
                {investorBanks.map((bank) => (
                  <MenuItem key={bank.id} value={bank.id}>
                    {bank.bankAccNo}
                  </MenuItem>
                ))}
              </TextField>

              {(() => {
                const selectedInv = investors.find((inv) => inv.id === formData.investorId);
                if (!selectedInv) return null;
                return (
                  <TextField
                    label="Demat Account"
                    name="selectedDemat"
                    value={formData.selectedDemat || 1}
                    onChange={handleEditChange}
                    select
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  >
                    <MenuItem value={1}>
                      {selectedInv.dpName || "Demat 1"} ({selectedInv.dpId || "No DP ID"})
                    </MenuItem>
                    {selectedInv.dpId2 && (
                      <MenuItem value={2}>
                        {selectedInv.dpName2 || "Demat 2"} ({selectedInv.dpId2})
                      </MenuItem>
                    )}
                  </TextField>
                );
              })()}

              {/* Brokerage - Editable */}
              <TextField
                label="Brokerage"
                name="brokerage"
                type="number"
                value={formData.brokerage}
                onChange={handleEditChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />

              {/* Remarks - Editable */}
              <TextField
                label="Remarks"
                name="remarks"
                type="text"
                value={formData.remarks}
                onChange={handleEditChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </div>

            <div className="mt-4 flex justify-end gap-4">
              <Button onClick={handleEditClose} color="secondary">
                Cancel
              </Button>
              <Button
                onClick={handleEditSubmit}
                variant="contained"
                className="bg-blue-600 text-white"
                disabled={
                  !formData.dealDate || !formData.quantity || !formData.rate
                }
              >
                Update Order
              </Button>
            </div>
          </Box>
        </Box>
      </Modal>
      {/* New Reject Modal */}
      <Modal open={isRejectModalOpen} onClose={handleRejectModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Box display="flex" justifyContent="space-between" mb={2}>
            <Typography variant="h6">Reject Order</Typography>
            <IconButton onClick={handleRejectModalClose}>
              <Close />
            </IconButton>
          </Box>
          <Box component="form" noValidate autoComplete="off">
            <TextField
              label="Rejection Reason"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              fullWidth
              multiline
              rows={4}
              required
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
            />
            <Box display="flex" justifyContent="flex-end" gap={2}>
              <Button
                onClick={handleRejectModalClose}
                color="secondary"
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={handleRejectSubmit}
                variant="contained"
                sx={{
                  backgroundColor: "#f44336",
                  "&:hover": { backgroundColor: "#d32f2f" },
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default UnlistedOrders;
